import axios from 'axios';

const localApiClient = axios.create({
  baseURL: process.env.REACT_APP_LOCAL_API_URL,
  timeout: 5000,
});

const FAKE_MODE = process.env.REACT_APP_LOCAL_API_FAKE === 'true';

export const fetchAlertStatus = async () => {
  const params = { status: 1 };
  if (FAKE_MODE) params.fake = true;
  const response = await localApiClient.get('/alerts/status', { params });
  return response.data;
};

export const fetchAllAlerts = async ({ limit = 20, offset = 0 } = {}) => {
  const response = await localApiClient.get('/alerts/status', { params: { limit, offset } });
  return response.data;
};

export const acknowledgeAlert = async (id, iEquip) => {
  const response = await localApiClient.post('/alerts/acknowledge', { id, iEquip });
  return response.data;
};
